// Uses the store's existing global-warehouses globe renderer.
import createGlobe from './tgw-cobe.js';
// Coordinates reused from the global warehouses page; regional navigation, not verified stock.
const globalPlaces = [['us','Colton · USA',34.060806,-117.305427],['ca','Canada',56,-106],['eu','Europe',50,12],['cn','China',35,105],['au','Australia',-25,134]];
const instances = new Map();
function mount(root) {
  if (instances.has(root)) return;
  const summary = root.hasAttribute('data-tcwh-summary');
  const places = summary ? globalPlaces.map(p => p[0]==='us' ? [p[0],'U.S. warehouse',p[2],p[3]] : p) : globalPlaces;
  const canvas = root.querySelector('canvas');
  const stage = root.querySelector('[data-tcwh-stage]');
  const controls = root.querySelector('[data-tcwh-controls]');
  const toggle = root.querySelector('[data-tcwh-spin]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const abort = new AbortController(), options = { signal: abort.signal };
  let globe, frame = 0, disposed = false, loading = false, visible = false;
  let zoom = 1.08, markerZoom = NaN;
  let phi = .28, theta = .5, auto = false, drag = null, last = 0, warmup = 0;
  let target = null, selected = null, routesDirty = true;
  const panel = document.createElement('aside'); panel.className='tcwh__detail'; panel.hidden=true;
  panel.setAttribute('aria-label','Region delivery and inventory');
  panel.innerHTML='<button type="button" class="tcwh__detail-close" aria-label="Close region details">×</button><p class="tcwh__detail-kicker">REGION ROLE</p><h3 tabindex="-1"></h3><p class="tcwh__detail-time"></p><p class="tcwh__detail-qualifier"></p><dl><dt>STATUS</dt><dd data-region-status></dd></dl><p class="tcwh__detail-stock"></p><div class="tcwh__route"><div class="tcwh__route-track"><span class="tcwh__route-plane" aria-hidden="true">✈</span></div><div class="tcwh__route-endpoints"><span>CHINA</span><span data-destination></span></div><p>Illustrative supply route only — not live tracking, a delivery-time promise, or a confirmed transport method.</p></div><a href="/pages/global-warehouses">EXPLORE GLOBAL WAREHOUSES ↗</a>';
  root.insertBefore(panel,stage);
  const title=panel.querySelector('h3');
  const summaryButtons=summary?[...root.parentElement.querySelectorAll('[data-tcwh-region]')]:[];
  summaryButtons.forEach(b=>b.addEventListener('click',()=>selectRegion(b.dataset.tcwhRegion),options));
  const delivery=summary?root.parentElement.querySelector('.tcwh-solo__delivery'):null;
  const spotlight=delivery?document.createElement('div'):null;
  const deliveryTimes=new Map(summaryButtons.map(b=>[b.dataset.tcwhRegion,b.closest('div').querySelector('dd').textContent]));
  if(spotlight){spotlight.className='tcwh-region-spotlight';spotlight.setAttribute('aria-live','polite');spotlight.setAttribute('aria-atomic','true');spotlight.innerHTML='<p class="tcwh-region-spotlight__name"></p><p class="tcwh-region-spotlight__time"></p><p class="tcwh-region-spotlight__caption"></p>';delivery.querySelector('.tcwh-summary-times').after(spotlight);delivery.classList.add('tcwh-selector-ready');updateSpotlight('us');}
  function updateSpotlight(id){if(!spotlight)return;const p=places.find(p=>p[0]===id);spotlight.querySelector('.tcwh-region-spotlight__name').textContent=id==='us'?'U.S. WAREHOUSE':p[1].toUpperCase();spotlight.querySelector('.tcwh-region-spotlight__time').textContent=deliveryTimes.get(id)||'Shipping origin';spotlight.querySelector('.tcwh-region-spotlight__caption').textContent=id==='cn'?'Orders ship from China':'Estimated delivery · calendar days';summaryButtons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.tcwhRegion===id)));}

  function selectRegion(id) {
    const p=places.find(p=>p[0]===id); if(!p)return; if(summary)updateSpotlight(id); if(!globe)return;
    stop();selected=id;routesDirty=true;zoom=1.12;
    labels.forEach(([key,b])=>b.setAttribute('aria-pressed',String(key===id)));
    if(summary){
      root.querySelector('.tcwh__globe-note').textContent=id==='cn'?'CHINA · SHIPPING ORIGIN':'CHINA → '+p[1].toUpperCase()+' · ILLUSTRATIVE '+(id==='us'?'SUPPLY ROUTE':'DELIVERY ROUTE');
      summaryButtons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.tcwhRegion===id)));
      target={phi:-Math.PI/2-p[3]*Math.PI/180,theta:p[2]*Math.PI/180};
      if(reduced.matches){phi=target.phi;theta=target.theta;target=null;}draw();return;
    }
    panel.hidden=false;root.classList.add('has-region-detail');
    title.textContent=p[1];
    const isDestination=!['us','cn'].includes(id);
    panel.querySelector('.tcwh__detail-kicker').textContent=id==='us'?'U.S. WAREHOUSE PROGRAM':id==='cn'?'CURRENT SHIPPING ORIGIN':'DELIVERY DESTINATION';
    panel.querySelector('.tcwh__detail-time').textContent=id==='us'?'Warehouse program in preparation':id==='cn'?'Current Shopify fulfillment origin':'Destination market only';
    panel.querySelector('[data-region-status]').textContent=id==='us'?'No U.S. local stock confirmed':id==='cn'?'China origin': 'No local TOCCAY warehouse confirmed';
    panel.querySelector('.tcwh__detail-qualifier').textContent=id==='us'?'The U.S. location and inventory feed are not connected. Planned inbound units are not available stock.':id==='cn'?'Current orders may be routed from China according to checkout and fulfillment settings.':`TOCCAY serves ${p[1].split(' · ')[0]} as a delivery destination; this marker does not represent an operating local warehouse.`;
    panel.querySelector('.tcwh__detail-stock').textContent=id==='us'?'Availability remains unconfirmed until an exact U.S. Shopify Location feed is verified.':isDestination?'No local inventory claim is made for this destination.':'This is an origin marker, not a local-stock promise.';
    panel.querySelector('.tcwh__route p').textContent='Illustrative supply route only — not live tracking, a delivery-time promise, or a confirmed transport method.';
    panel.querySelector('[data-destination]').textContent=p[1];
    panel.querySelector('.tcwh__route').hidden=id==='cn';
    target={phi:-Math.PI/2-p[3]*Math.PI/180,theta:p[2]*Math.PI/180};
    if(reduced.matches){phi=target.phi;theta=target.theta;target=null;}
    title.focus({preventScroll:true});draw();
  }
  function closeRegion(restoreFocus=false) {
    const previous=selected;stop();selected=null;routesDirty=true;zoom=1.08;phi=.28;theta=.5;
    panel.hidden=true;root.classList.remove('has-region-detail');
    if(summary)root.querySelector('.tcwh__globe-note').textContent='DRAG TO EXPLORE · SELECT A REGION';
    summaryButtons.forEach(b=>b.setAttribute('aria-pressed','false')); 
    if(summary)updateSpotlight('us');
    labels.forEach(([,b])=>b.setAttribute('aria-pressed','false'));
    if(restoreFocus)labels.find(([id])=>id===previous)?.[1].focus({preventScroll:true});draw();
  }
  panel.querySelector('.tcwh__detail-close').addEventListener('click',()=>closeRegion(true),options);
  root.addEventListener('keydown',e=>{if(e.key==='Escape'&&!panel.hidden){e.preventDefault();closeRegion(true);}},options);

  const regionNav = document.createElement('div');
  regionNav.className = 'tcwh__region-nav'; regionNav.setAttribute('role','group');
  regionNav.setAttribute('aria-label','Explore a region on the globe');
  root.insertBefore(regionNav, controls);
  const labels = places.map(([id, name, lat, lon]) => {
    const button = document.createElement('button'); button.type = 'button';
    button.textContent = name; button.disabled = true;
    button.setAttribute('aria-pressed','false');
    button.addEventListener('click', () => selectRegion(id), options);
    regionNav.append(button); return [id, button];
  });
  const surfaceNames = places.map(([id,name,lat,lon]) => {
    const node = document.createElement('button'); node.type='button'; node.className='tcwh__surface-name';
    node.addEventListener('click',()=>selectRegion(id),options);
    node.textContent=name; node.hidden=true; stage.append(node);
    return {id,node,lat:lat*Math.PI/180,lon:lon*Math.PI/180};
  });
  function positionNames() {
    for (const item of surfaceNames) {
      const anchor=stage.querySelector('[style*="anchor-name: --cobe-'+item.id+';"]') || stage.querySelector('[style*="anchor-name:--cobe-'+item.id+';"]');
      const front=-Math.cos(item.lat)*Math.sin(item.lon+phi)*Math.cos(theta)+Math.sin(item.lat)*Math.sin(theta);
      if (!anchor || front < .38 || !root.classList.contains('is-ready')) {item.node.hidden=true;continue;}
      const x=parseFloat(anchor.style.left),y=parseFloat(anchor.style.top);
      item.node.hidden=!Number.isFinite(x)||!Number.isFinite(y)||x<12||x>88||y<12||y>88;
      item.node.style.left=anchor.style.left; item.node.style.top=anchor.style.top;
    }
  }
  const routeDot=document.createElement('span');routeDot.className='tcwh__route-dot';routeDot.hidden=true;stage.append(routeDot);
  const vector=(lat,lon)=>{const a=lat*Math.PI/180,b=lon*Math.PI/180;return [Math.cos(a)*Math.cos(b),Math.sin(a),-Math.cos(a)*Math.sin(b)];};
  function paintRouteDot(now){
    const p=places.find(p=>p[0]===selected);if(!p||selected==='cn'){routeDot.hidden=true;return;}
    const a=vector(35,105),b=vector(p[2],p[3]),m=a.map((x,i)=>x+b[i]),length=Math.hypot(...m);
    if(length<.001){routeDot.hidden=true;return;}
    const t=reduced.matches?.5:(now%6500)/6500,u=1-t;
    const q=a.map((x,i)=>u*u*x*.8+2*u*t*m[i]/length*.92+t*t*b[i]*.8);
    const x=Math.cos(phi)*q[0]+Math.sin(phi)*q[2],z0=Math.sin(phi)*q[0]-Math.cos(phi)*q[2];
    const y=Math.sin(theta)*z0+Math.cos(theta)*q[1],z=-Math.cos(theta)*z0+Math.sin(theta)*q[1];
    routeDot.hidden=z<.04||!root.classList.contains('is-ready');routeDot.style.left=(50+x*50*zoom)+'%';routeDot.style.top=(50-y*50*zoom)+'%';
  }
  const markers = () => places.map(([id,,lat,lon]) => ({id, location:[lat,lon],size:.022 / Math.sqrt(zoom),color:[.18,.18,.18]}));
  const clamp = n => Math.max(-1.2, Math.min(1.2, n));
  function paint(now = performance.now()) {
    frame = 0;
    if (!globe || disposed || !visible || document.hidden) return;
    if (auto && !reduced.matches && !drag) phi += Math.min(now - last || 16, 40) * .00012;
    if (target) {
      const ease = 1 - Math.exp(-Math.min(now-last || 16, 40)/110);
      const delta = Math.atan2(Math.sin(target.phi-phi), Math.cos(target.phi-phi));
      phi += delta*ease; theta += (target.theta-theta)*ease;
      if (Math.abs(delta) < .001 && Math.abs(target.theta-theta) < .001) target=null;
    }
    last = now;
    const update = { phi, theta, scale: zoom };
    if (markerZoom !== zoom) { update.markers = markers(); markerZoom = zoom; }
    if(routesDirty){const p=places.find(p=>p[0]===selected);update.arcs=p&&selected!=='cn'?[{from:[35,105],to:[p[2],p[3]],color:[.25,.29,.32]}]:[];routesDirty=false;}
    globe.update(update);
    if (now > warmup - 1200) { root.classList.add('is-ready'); controls.hidden = false; labels.forEach(([,b]) => { b.disabled=false; }); }

    positionNames(); paintRouteDot(now);
    if ((selected && selected!=='cn' && !reduced.matches) || target || (auto && !reduced.matches) || now < warmup) frame = requestAnimationFrame(paint);
  }
  function draw() { if (!frame) frame = requestAnimationFrame(paint); }
  function stop() {
    auto = false; target = null;
    labels.forEach(([id,b]) => b.setAttribute('aria-pressed',String(id===selected)));
    toggle.textContent = 'AUTO ROTATE';
    toggle.setAttribute('aria-pressed', 'false');
  }
  async function start() {
    if (loading || globe || disposed) return;
    loading = true;
    try {
      if (disposed) return;
      if (!canvas.getContext('webgl2') && !canvas.getContext('webgl')) throw Error('WebGL unavailable');
      const size = stage.clientWidth;
      globe = createGlobe(canvas, {
        width: size, height: size, devicePixelRatio: 2,
        phi, theta, dark: 0, diffuse: 1, mapSamples: 18000,
        mapBrightness: 1.05, mapBaseBrightness: 0,
        baseColor: [.91, .92, .92], markerColor: [.35, .35, .35],
        glowColor: [.72, .73, .72], scale: 1.08, markerElevation: 0, arcHeight: .12, arcWidth: .4, markers: markers()
      });
      warmup = performance.now() + 2000; draw();
    } catch (error) { root.classList.add('is-fallback'); console.warn('TOCCAY globe could not initialize:', error.message); }
  }
  const observer = new IntersectionObserver(([entry]) => {
    visible = entry.isIntersecting;
    if (visible) { warmup = performance.now() + 2000; start(); draw(); }
    else { cancelAnimationFrame(frame); frame = 0; }
  }, { rootMargin: '100px' });
  observer.observe(root);
  start();
  const resize = new ResizeObserver(() => {
    if (globe) { const size = stage.clientWidth; globe.update({ width: size, height: size }); draw(); }
  });
  resize.observe(stage);
  canvas.addEventListener('pointerdown', event => {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    stop(); drag = { id: event.pointerId, x: event.clientX, y: event.clientY };
    canvas.setPointerCapture(event.pointerId);
  }, options);
  canvas.addEventListener('pointermove', event => {
    if (!drag || drag.id !== event.pointerId) return;
    phi += (event.clientX - drag.x) / 180;
    theta = clamp(theta + (event.clientY - drag.y) / 180);
    drag.x = event.clientX; drag.y = event.clientY; draw();
  }, options);
  for (const type of ['pointerup', 'pointercancel', 'lostpointercapture']) canvas.addEventListener(type, () => { drag = null; }, options);
  canvas.addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', '+', '=', '-'].includes(event.key)) return;
    event.preventDefault(); stop();
    if (event.key === 'Home') { closeRegion(); }
    else if (['+', '=', '-'].includes(event.key)) { zoom = Math.max(.8, Math.min(1.2, zoom + (event.key === '-' ? -.1 : .1))); }
    else { phi += event.key === 'ArrowLeft' ? -.15 : event.key === 'ArrowRight' ? .15 : 0;
      theta = clamp(theta + (event.key === 'ArrowUp' ? .15 : event.key === 'ArrowDown' ? -.15 : 0)); }
    draw();
  }, options);
  root.querySelectorAll('[data-tcwh-turn]').forEach(button => button.addEventListener('click', () => {
    stop(); phi += Number(button.dataset.tcwhTurn) * .25; draw();
  }, options));
  root.querySelectorAll('[data-tcwh-zoom]').forEach(button => button.addEventListener('click', () => {
    zoom = Math.max(.8, Math.min(1.2, zoom + Number(button.dataset.tcwhZoom) * .1)); draw();
  }, options));
  root.querySelector('[data-tcwh-reset]')?.addEventListener('click', () => closeRegion(), options);

  toggle.addEventListener('click', () => {
    if (auto) stop(); else if (!reduced.matches) { stop(); auto = true; toggle.textContent = 'PAUSE ROTATION'; toggle.setAttribute('aria-pressed', 'true'); }
    draw();
  }, options);
  const motion = () => { stop(); toggle.disabled = reduced.matches; draw(); };
  reduced.addEventListener('change', motion, options); motion();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) { last = 0; draw(); } }, options);
  canvas.addEventListener('webglcontextlost', event => {
    event.preventDefault(); stop(); cancelAnimationFrame(frame); frame = 0;
    root.classList.remove('is-ready'); controls.hidden = true; labels.forEach(([,b]) => { b.disabled=true; });
  }, options);
  instances.set(root, () => {
    disposed = true; abort.abort(); observer.disconnect(); resize.disconnect();
    cancelAnimationFrame(frame); globe?.destroy();
    const wrapper = canvas.parentElement;
    if (wrapper !== stage && wrapper?.parentElement === stage) { stage.append(canvas); wrapper.remove(); }
    root.classList.remove('is-ready'); controls.hidden = true;
    surfaceNames.forEach(({node}) => node.remove());
    routeDot.remove();
    panel.remove(); root.classList.remove('has-region-detail');
    spotlight?.remove(); delivery?.classList.remove('tcwh-selector-ready');
    regionNav.remove();
    instances.delete(root);
  });
}
function scan(scope = document) { scope.querySelectorAll('[data-tcwh-globe]').forEach(mount); }
scan();
document.addEventListener('shopify:section:load', event => scan(event.target));
document.addEventListener('shopify:section:unload', event => {
  for (const [root, destroy] of instances) if (event.target.contains(root)) destroy();
});
window.addEventListener('pagehide', () => { for (const destroy of instances.values()) destroy(); });
window.addEventListener('pageshow', () => scan());
